import React from "react";
import PropTypes from "prop-types";

import Skills from "./Skills";

class Category extends React.Component {
  changeCategoryName = e => {
    const { category, onChangeCategoryName } = this.props;
    onChangeCategoryName((category.id || category._id), e.target.value);
  };

  changeSkillName = (skillId, value) => {
    const { category, onChangeSkillName } = this.props;
    onChangeSkillName((category.id || category._id), skillId, value);
  };

  addSkill = () => {
    const { category, onAddSkill } = this.props;
    onAddSkill((category.id || category._id));
  };

  deleteCategory = () => {
    const { category, onDeleteCategory } = this.props;
    onDeleteCategory(category.id || category._id);
  };

  deleteSkill = skillId => {
    const { category, onDeleteSkill } = this.props;
    onDeleteSkill((category.id || category._id), skillId);
  };

  render() {
    const { category, isLast } = this.props;
    let { id, _id, name, skills } = category;
    id = id || _id;

    return (
      <div className="mb-15">
        <div className="form-group">
          <label className="control-label required" htmlFor={`category${id}`}>Category</label>
          <div className="row">
            <div className="col-sm-9">
              <input
                id={`category${id}`}
                className="form-control"
                value={name}
                onChange={this.changeCategoryName}
              />
            </div>
            <div className="col-sm-3">
              <button
                className="btn btn-grey btn-raised btn-block"
                onClick={this.deleteCategory}
              >
                REMOVE CATEGORY
              </button>
            </div>
          </div>
        </div>

        <Skills
          skills={skills}
          onChangeSkillName={this.changeSkillName}
          onAddSkill={this.addSkill}
          onDeleteSkill={this.deleteSkill}
        />

        {isLast ? null : <div className="separate-line" />}
      </div>
    );
  }
}

Category.propTypes = {
  category: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
  onChangeCategoryName: PropTypes.func,
  onChangeSkillName: PropTypes.func,
  onDeleteCategory: PropTypes.func,
  onAddSkill: PropTypes.func,
  onDeleteSkill: PropTypes.func
};

Category.defaulProps = {
  isLast: false
};

export default Category;
